module.exports = __webpack_public_path__ + "img/Overallunction_pic.97c4ddb7.png";